export enum DriverStatus {
    Inactive = -1,
    Active = 0
}

export const DriverStatusMetadata = {    
    '0': {
        display: 'Active',
        value: 0
    },
    '-1': {
        display: 'Inactive',
        value: -1
    }
};
